import { roundOffAndFormatNumberWithCurrency } from '../../../utils/utils'
import { AlertBadge } from './AlertBadge'
import { HeadingWithHighlight } from './HeadingWithHighlight'
import { RegularPlanFundCard } from './RegularPlanFundCard'
import { InfoCard } from './InfoCard'
import type { SingleFundCommissionsData } from '../types'

interface VariationSingleFundCommissionsProps {
  data: SingleFundCommissionsData
}

export function VariationSingleFundCommissions({ data }: VariationSingleFundCommissionsProps) {
  const formattedAmount = roundOffAndFormatNumberWithCurrency(data?.commissionAmount ?? 0)

  return (
    <div className="flex flex-col">
      <AlertBadge label="Regular Fund Detected" />
      <HeadingWithHighlight
        before="You've "
        highlight={`paid ${formattedAmount} extra`}
        after=" due to high expense ratio in this fund"
      />
      <div className='pt-6 pb-4'>
        <RegularPlanFundCard fund={data?.fund ?? null} />
      </div>
      {/* <InfoCard
        heading="Know how to avoid further commissions"
        body="Unlock your Regular to Direct Plan and switch to direct funds tax-efficiently"
      /> */}
    </div>
  )
}
